import { getPeople, getPerson, getPeopleKpi } from '@/graphl/queries/people'
import { formatDate, formatPrice } from '@/helpers'

const state = {
  listPeople: [],
  loading: false,
  personData: {},
  metaDataPeople: {},
  notFoundFilter: false,
  kpiData: [],
  filter: {
    name: null,
    status: null,
    dateType: null,
    dateStart: null,
    dateEnd: null
  },
}

const mutations = {
  'TOGGLE_LOADING_PEOPLE' (state, payload = false) {
    state.loading = !!payload
  },
  'SET_PEOPLE_LIST' (state, payload) {
    state.listPeople = payload
  },
  'SET_PERSON' (state, payload) {
    state.personData = payload
  },
  'SET_METADATA_PEOPLE' (state, payload) {
    state.metaDataPeople = payload
  },
  'TOGGLE_ERROR_SEARCH' (state, payload = false) {
    state.notFoundFilter = !!payload
  },
  'SET_FILTER' (state, payload) {
    state.filter = payload
  },
  'SET_KPI' (state, payload) {
    state.kpiData = payload
  }
}

const actions = {
  getAllPeople ({commit}, page, limit, campaignId ) {
    commit('TOGGLE_LOADING_PEOPLE', true)
    getPeople (page, limit, campaignId).then( res => {
      const { collection } = res.data.people
      const { metadata } = res.data.people

      this.people = collection.map((person) => ({
        id: person.id,
        status: person.humanizedStatus,
        name: person.name,
        data: person.payments[0] ? formatDate(person.payments[0].paidAt) : '--',
        payment: person.payments[0] ? formatPrice(person.payments[0].value) : '--'
      }))

      commit('SET_PEOPLE_LIST', this.people)
      commit('SET_METADATA_PEOPLE', metadata)
      commit('TOGGLE_LOADING_PEOPLE', false)
    }).catch(e => {
      this.erros = e
      commit('TOGGLE_LOADING_PEOPLE', false)
    })
  },

  getPeopleId ({commit}, id) {
    commit('TOGGLE_LOADING_PEOPLE', true)
    getPerson (id)
    .then( res => {
      this.personData = res.data.person
      commit('SET_PERSON', this.personData)
      commit('TOGGLE_LOADING_PEOPLE', false)
    }).catch(e => {
      this.erros = e
    })
  },

  searchPeople ({commit}, params = {} ) {
    commit('TOGGLE_ERROR_SEARCH', false)
    commit('TOGGLE_LOADING_PEOPLE', true)
    getPeople (params).then( res => {
      const { collection } = res.data.people
      const { metadata } = res.data.people
      this.people = collection.map((person) => ({
        id: person.id,
        status: person.humanizedStatus,
        name: person.name,
        data: person.payments[0] ? formatDate(person.payments[0].paidAt) : '--',
        payment: person.payments[0] ? formatPrice(person.payments[0].value) : '--'
      }))
      commit('SET_PEOPLE_LIST', this.people)
      commit('SET_METADATA_PEOPLE', metadata)
      commit('TOGGLE_LOADING_PEOPLE', false)
      if(this.people.length === 0){
        commit('TOGGLE_ERROR_SEARCH', true)
      }
    }).catch(e => {
      this.erros = e
      commit('TOGGLE_LOADING_PEOPLE', false)
    })
  },

  infoPeople ({commit}, params = {} ) {
    getPeople (params).then( res => {
      const { collection } = res.data.people
      const { metadata } = res.data.people
      this.people = collection.map((person) => ({
        id: person.id,
        status: person.humanizedStatus,
        name: person.name,
        data: person.payments[0] ? formatDate(person.payments[0].paidAt) : '--',
        payment: person.payments[0] ? formatPrice(person.payments[0].value) : '--'
      }))
      commit('SET_METADATA_PEOPLE', metadata)
      commit('TOGGLE_LOADING_PEOPLE', false)
      if(this.people.length === 0){
        commit('TOGGLE_ERROR_SEARCH', true)
      }
    }).catch(e => {
      this.erros = e
      commit('TOGGLE_LOADING_PEOPLE', false)
    })
  },

  getKpi ({commit}, params = {} ) {
    getPeopleKpi (params).then(res => {
      commit('SET_KPI', res.data.kpiPeople)
      commit('TOGGLE_LOADING_PEOPLE', false)
    }).catch(e => {
      this.erros = e
      commit('TOGGLE_LOADING_PEOPLE', false)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
